import styled from "@emotion/styled";
import Bookmark from "scmp-sdk/components/acquisition-popup-container/display/popups/why-register/svgs/bookmark.svg";
import Comment from "scmp-sdk/components/acquisition-popup-container/display/popups/why-register/svgs/comment.svg";
import ScmpLogo from "scmp-sdk/components/acquisition-popup-container/display/popups/why-register/svgs/flag.svg";
import Plus from "scmp-sdk/components/acquisition-popup-container/display/popups/why-register/svgs/plus.svg";
import Star from "scmp-sdk/components/acquisition-popup-container/display/popups/why-register/svgs/star.svg";

import { fontMerriweather, fontRoboto, theme } from "shared/lib/styles";

export const ContainerWrapper = styled.div``;

export const Container = styled.div`
  position: relative;

  inline-size: 300px;
  min-block-size: 449px;
  margin: auto;
  padding-block: 16px;
  padding-inline: 24px;

  background-color: #f1ecdc;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 600px;
    max-inline-size: 600px;
    min-block-size: 407px;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;

  #sa-login-widget {
    inline-size: 100%;

    ${theme.breakpoints.up("tablet")} {
      max-inline-size: 252px;
    }
  }

  .sa-google-login-button {
    margin-block-end: 0;
  }

  .sa-login-widget {
    inline-size: 100%;
  }
`;

export const Title = styled.div`
  max-inline-size: 252px;
  margin-block: 16px 0;

  color: #001246;
  font-weight: 900;
  font-size: 16px;
  font-family: ${fontMerriweather};
  line-height: 20px;
  text-align: center;

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 480px;
    margin-block: 16px 0;

    font-weight: 900;
    font-size: 24px;
    font-family: ${fontMerriweather};
    line-height: 30.17px;
  }
`;

export const StyledScmpLogo = styled(ScmpLogo)`
  inline-size: 33px;
  block-size: 25px;
`;

export const IconContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;

  margin-block: 16px 0;
`;

export const StyledBookmark = styled(Bookmark)`
  inline-size: 40px;
  block-size: 40px;
  margin-inline: 4px;
`;

export const StyledComment = styled(Comment)`
  inline-size: 40px;
  block-size: 40px;
  margin-inline: 4px;
`;

export const StyledPlus = styled(Plus)`
  inline-size: 40px;
  block-size: 40px;
  margin-inline: 4px;
`;

export const StyledStar = styled(Star)`
  inline-size: 40px;
  block-size: 40px;
  margin-inline: 4px;
`;

export const IntroductionContainer = styled.div`
  max-inline-size: 360px;
  margin-block: 16px 0;
  margin-inline: 6px 0;

  ${theme.breakpoints.up("tablet")} {
    margin-block: 16px 0;
    margin-inline: 0;
  }
`;

export const IntroductionLine = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: flex-start;

  padding-block: 0 8px;

  color: #001246;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 130%;

  &:last-of-type {
    padding: 0;
  }

  ${theme.breakpoints.up("tablet")} {
    font-size: 16px;
    font-family: ${fontRoboto};
  }
`;

export const IntroductionNumber = styled.div`
  margin-inline: 0 7px;
`;

export const IntroductionHTML = styled.span``;

export const AccountSignUpContainer = styled.div`
  inline-size: 100%;
  margin-block: 16px 0;

  .sa-login-widget-title {
    display: none;
  }
`;

export const OtherSignUpMethodMessage = styled.div`
  margin-block: 16px 0;

  color: #4585ff;
  font-size: 14px;
  font-family: ${fontRoboto};

  cursor: pointer;
  border-block-end: 1px #4585ff solid;
`;
